export default "__VITE_ASSET__Cd6$yt3p__"